import {IMappingOriginOptionOpts} from "~/interfaces/mappingInterfaces";
import {Logger} from "~/services/logger";
import MappingOrigin from "~/models/mapping/mappingOrigin";

export default abstract class MappingOriginOption<T = any> implements IMappingOriginOptionOpts<T> {
  origin: T;
  abstract readonly ORIGIN_TYPE: 'model' | 'relation' | 'form' | 'formElement' | 'paymentStep' | 'paymentStepLineItem' | 'salesforce'
  abstract type: 'single' | 'multi'
  abstract title: string
  abstract id: string // mainly for use as a unique identifier in UI

  constructor(opts: IMappingOriginOptionOpts<T>) {
    if (opts.origin) {
      this.origin = opts.origin
    } else {
      Logger.errorOnce('MappingOriginOption', 'Origin not provided for MappingOriginOption')
    }
  }

  isMatch(id: string): boolean {
    return this.id === id;
  }

  addToMappingOrigin(mappingOrigin: MappingOrigin) {
    if (mappingOrigin.modelIdentifiers.includes(this.id)) return
    if (mappingOrigin.rootIdentifier === this.id) return // don't ever add root identifier model identifiers
    mappingOrigin.modelIdentifiers = [...mappingOrigin.modelIdentifiers, this.id];
  }
}